import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { AuthEventData } from '@aws-amplify/ui';
import { AmplifyUser } from '@aws-amplify/ui/dist/types/types/authenticator/user';

import HeaderLayout from 'components/layout/header-layout';
import SidebarLayout from 'components/layout/sidebar-layout';
import NotFoundPage from 'pages/not-found-page';
import DashboardPage from 'pages/dashboard-page';
import withReport from 'components/with-report';
import ImportDataPage from 'pages/import-data-page';
import UploadFilePage from 'pages/upload-file-page';
import ImportingHRISDataPage from 'pages/importing-hris-data-page';
import ReviewDataPage from 'pages/review-data-page';
import JobCategoryConfirmationPage from 'pages/job-category-confirmation-page';
import AddEstablishmentDetailsPage from 'pages/add-establishment-details-page';
import PreviewReportPage from 'pages/preview-report-page';
import DownloadReportPage from 'pages/download-report-page';
import HowToFilePage from 'pages/how-to-file-page';
import GustoOauthCallback from 'components/import-data-page/gusto-oauth-callback';
import {
  ROOT_PATH,
  NOT_FOUND_PATH,
  REPORT_PATH,
  UPLOAD_FILE_PATH,
  IMPORT_DATA_PATH,
  IMPORTING_HRIS_DATA_PATH,
  REVIEW_DATA_PATH,
  JOB_CATEGORY_CONFIRMATION_PATH,
  ADD_ESTABLISHMENT_DETAILS_PATH,
  PREVIEW_REPORT_PATH,
  DOWNLOAD_REPORT_PATH,
  GUSTO_OAUTH_CALLBACK_PATH,
  HOW_TO_FILE_PATH
} from 'constants/paths';

function Router({
  user,
  signOut
}: {
  user: AmplifyUser | undefined;
  signOut: ((data?: AuthEventData | undefined) => void) | undefined;
}): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const ReportPage = withReport();
  const pageElementKey = location.pathname;

  const handleSignOut = (): void => {
    void (async () => {
      if (signOut != null) {
        await signOut();
        navigate(ROOT_PATH);
      }
    })();
  };

  return (
    <Routes>
      <Route path={ROOT_PATH} element={<SidebarLayout user={user} signOut={handleSignOut} />}>
        <Route path={ROOT_PATH} element={<DashboardPage />} />
        <Route path={HOW_TO_FILE_PATH} element={<HowToFilePage />} />
      </Route>
      <Route path={ROOT_PATH} element={<HeaderLayout user={user} signOut={handleSignOut} />}>
        <Route path={NOT_FOUND_PATH} element={<NotFoundPage />} />
        <Route path={REPORT_PATH} element={<ReportPage key={pageElementKey} />} />
        <Route path={IMPORT_DATA_PATH} element={<ImportDataPage key={pageElementKey} />} />
        <Route
          path={IMPORTING_HRIS_DATA_PATH}
          element={<ImportingHRISDataPage key={pageElementKey} />}
        />
        <Route path={UPLOAD_FILE_PATH} element={<UploadFilePage key={pageElementKey} />} />
        <Route
          path={JOB_CATEGORY_CONFIRMATION_PATH}
          element={<JobCategoryConfirmationPage key={pageElementKey} />}
        />
        <Route
          path={ADD_ESTABLISHMENT_DETAILS_PATH}
          element={<AddEstablishmentDetailsPage key={pageElementKey} />}
        />
        <Route path={PREVIEW_REPORT_PATH} element={<PreviewReportPage key={pageElementKey} />} />
        <Route path={DOWNLOAD_REPORT_PATH} element={<DownloadReportPage key={pageElementKey} />} />
        <Route path={REVIEW_DATA_PATH} element={<ReviewDataPage key={pageElementKey} />} />
        <Route path={GUSTO_OAUTH_CALLBACK_PATH} element={<GustoOauthCallback />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default Router;
